// Arabisch (ar), family: zelfde vorm als family.nl.ts. Wensen, kalenders, familie en berichten;
// op de kiosk eenvoudige woorden voor kinderen.
export const familyAr = {
    nav: {
        wishes: 'الأمنيات',
        messages: 'الرسائل',
        calendars: 'التقاويم',
        family: 'الأقارب',
    },
    common: {
        save: 'حفظ',
        saved: 'تم الحفظ.',
        add: 'إضافة',
        edit: 'تعديل',
        remove: 'إزالة',
        undo: 'تراجع',
        copy: 'نسخ الرابط',
        copied: 'تم نسخ الرابط.',
        readOnly: 'للقراءة فقط',
        everyone: 'الجميع',
        loading: 'لحظة، جارٍ التحميل…',
        retry: 'حاول مرة أخرى',
        error: 'حدث خطأ ما. حاول مرة أخرى.',
        back: 'رجوع',
        close: 'إغلاق',
        whoAreYou: 'من أنت؟',
        readAloud: 'اقرأ بصوت عالٍ',
        inDays: {
            zero: 'اليوم',
            one: 'غدًا',
            two: 'بعد يومين',
            few: 'بعد {count} أيام',
            many: 'بعد {count} يومًا',
            other: 'بعد {count} يوم',
        },
        today: 'اليوم',
        turnsAge: 'يبلغ {age}',
        dayOf: 'اليوم {index} من {count}',
    },
    wishes: {
        title: 'الأمنيات',
        intro: 'ماذا في قوائم الأمنيات؟ يختار الأطفال صورة بأنفسهم على الجهاز اللوحي.',
        add: 'إضافة أمنية',
        addShort: 'أمنية',
        listOf: 'أمنيات {name}',
        editTitle: 'تعديل الأمنية',
        newTitle: 'أمنية جديدة',
        fieldTitle: 'ما هي؟',
        fieldTitleHint: 'قصيرة وواضحة، مثلًا: دراجة توازن',
        fieldFor: 'لمن',
        fieldPicto: 'الصورة',
        fieldNote: 'توضيح',
        fieldNoteHint: 'المقاس أو اللون أو الماركة (اختياري)',
        fieldUrl: 'رابط المتجر',
        fieldUrlHint: 'يبدأ بـ https:// (اختياري)',
        fieldPrice: 'تقريبًا (€)',
        fieldPriority: 'كم يريدها؟',
        priority1: 'جميلة',
        priority2: 'جميلة جدًا',
        priority3: 'الأحب إليّ',
        received: 'وصلت',
        markReceived: 'وصلت',
        fromTablet: 'اختارها بنفسه على الجهاز اللوحي: اختاروا معًا ما هي بالضبط',
        removed: 'أُزيلت {title}.',
        receivedToast: '{title} ضمن ما وصل.',
        share: 'مشاركة',
        shareTitle: 'مشاركة قائمة {name}',
        shareIntro: 'كل من لديه هذا الرابط يمكنه رؤية القائمة وحجز هدية، دون حساب. لا يرى {name} أبدًا من يشتري ماذا.',
        shareCreate: 'إنشاء رابط مشاركة',
        shareNew: 'رابط جديد',
        shareNewHint: 'بعدها لن يعمل الرابط القديم.',
        shareStop: 'إيقاف المشاركة',
        shareStopped: 'لم تعد القائمة مشتركة.',
        shared: 'مشتركة',
        reveal: 'كشف',
        revealHint: 'يظهر ما تم شراؤه. انتبه: قد يرى الأطفال الشاشة.',
        claimedBy: '{name} سيشتريها',
        claimedAnon: 'أحدهم سيشتريها',
        boughtBy: '{name} اشتراها',
        boughtAnon: 'اشتُريت',
        emptyTitle: 'لا أمنيات بعد',
        emptyBody: 'أضف أمنية، أو دع {name} يختار واحدة على الجهاز اللوحي.',
        urlInvalid: 'استخدم رابطًا يبدأ بـ https://',
    },
    share: {
        title: 'قائمة أمنيات {name}',
        intro: 'اختر هدية. لا يرى {name} من يشتري ماذا.',
        claim: 'سأشتري هذه',
        claimTitle: 'تقديم هذه الهدية',
        claimName: 'اسمك (اختياري)',
        claimNameHint: 'حتى يرى الآخرون أنها محجوزة.',
        claimConfirm: 'سأشتري هذه',
        mine: 'أنت ستشتريها',
        mineBought: 'أنت اشتريتها',
        bought: 'اشتُريت',
        release: 'لا، تراجعت',
        taken: 'أحدهم سيشتريها',
        takenBy: '{name} سيشتريها',
        goneTitle: 'هذا الرابط لم يعد يعمل',
        goneBody: 'اطلب رابطًا جديدًا.',
        emptyTitle: 'القائمة فارغة بعد',
        emptyBody: 'عد لاحقًا.',
        footer: 'صُنعت بلوحة العائلة من AMUMIN. لا حاجة إلى حساب.',
        toWebshop: 'شاهدها في المتجر',
    },
    days: {
        title: 'التقاويم',
        intro: 'أعياد الميلاد والعطل الرسمية والعطل المدرسية والتقاويم المربوطة تظهر تلقائيًا في الأجندة.',
        upcoming: 'قريبًا',
        upcomingEmpty: 'لا شيء مميز في الأسابيع القادمة.',
        layers: 'ماذا يظهر في الأجندة؟',
        layerBirthdays: 'أعياد الميلاد',
        layerBirthdaysHint: 'للعائلة وللعائلات التي تشارك أعياد ميلادها.',
        layerHolidays: 'العطل والمناسبات',
        layerHolidaysHint: 'يوم الملك وعيد الفصح وعيد الميلاد المجيد وأيام مثل عيد الأم.',
        layerSchool: 'العطل المدرسية',
        region: 'المنطقة',
        regionNoord: 'الشمال',
        regionMidden: 'الوسط',
        regionZuid: 'الجنوب',
        regionOff: 'إيقاف',
        regionHint: 'في أي منطقة مدرستكم؟ مواعيد عطل الخريف وعيد الميلاد المجيد والربيع ومايو استرشادية.',
        birthdays: 'أعياد الميلاد',
        birthdaysHint: 'أدخل تاريخ الميلاد ليظهر عيد الميلاد في الأجندة.',
        birthDate: 'تاريخ ميلاد {name}',
        birthDateSaved: 'عيد ميلاد {name} في الأجندة الآن.',
    },
    feeds: {
        title: 'التقاويم المربوطة',
        add: 'ربط تقويم',
        addTitle: 'ربط تقويم',
        intro: 'اجلب مواعيد المدرسة والرياضة والعمل تلقائيًا. تُحدَّث كل نصف ساعة.',
        provider: 'من أين يأتي التقويم؟',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'غير ذلك',
        },
        howto: {
            google: 'إعدادات التقويم ← دمج التقويم ← العنوان السري بتنسيق iCal.',
            icloud: 'التقويم ← مشاركة التقويم ← تقويم عام ← انسخ رابط webcal.',
            outlook: 'الإعدادات ← التقويم ← التقويمات المشتركة ← نشر ← رابط ICS.',
            parro: 'Parro ← الإعدادات ← ربط التقويم ← انسخ الرابط.',
            magister: 'Magister ← الأجندة ← مشاركة الأجندة ← انسخ الرابط.',
            sportlink: 'Voetbal.nl ← البرنامج ← أضف إلى تقويمك ← انسخ رابط iCal.',
            other: 'يعمل أي رابط ينتهي بـ .ics أو يبدأ بـ webcal://',
        },
        url: 'الرابط',
        urlHint: 'يبدأ بـ webcal:// أو https://',
        name: 'الاسم',
        namePlaceholder: 'مثلًا: المدرسة',
        forWho: 'لمن',
        forWhoHint: 'إن لم تختر أحدًا = للجميع.',
        review: 'اعرض المواعيد غير المعروفة أولًا',
        reviewHint: 'مفيد عند وجود أجندة مدرسية واحدة لعدة أطفال.',
        rules: 'القواعد',
        rulesHint: 'هل يظهر هذا في العنوان؟ إذن هو لـ…',
        ruleContains: 'النص',
        rulePlaceholder: 'مثلًا: الصف 3',
        addRule: 'إضافة قاعدة',
        connect: 'ربط',
        connected: 'تم ربط {name}: {count} مواعيد.',
        refresh: 'تحديث الآن',
        refreshed: 'تم التحديث.',
        remove: 'فك الربط',
        removeConfirm: 'فك ربط تقويم {name}؟ ستختفي مواعيده من أجندتكم.',
        removed: 'تم فك ربط {name}.',
        statusOk: 'حُدّث {ago}',
        statusNew: 'لم يُجلب بعد',
        statusStale: 'قديم: لم يمكن الوصول إليه منذ يوم',
        statusError: 'لم ينجح: {error}',
        items: {
            zero: 'لا مواعيد',
            one: 'موعد واحد',
            two: 'موعدان',
            few: '{count} مواعيد',
            many: '{count} موعدًا',
            other: '{count} موعد',
        },
        reviewCount: 'غير معروف ({count})',
        reviewTitle: 'لمن هذا؟',
        reviewIntro: 'اختر لكل موعد لمن هو. يبقى كذلك حتى بعد التحديث.',
        hide: 'إخفاء',
        assign: 'تعيين',
        readonlyNote: 'العنوان والوقت من التقويم المربوط.',
        emptyTitle: 'لا تقويم مربوط بعد',
        emptyBody: 'اجلب مواعيد المدرسة والرياضة والعمل تلقائيًا.',
    },
    links: {
        title: 'الأقارب والأصدقاء',
        intro: 'اربطوا الجد والجدة أو الوالد الآخر أو الأصدقاء. أنتم تختارون ما تشاركونه.',
        add: 'ربط الأقارب',
        addTitle: 'ربط الأقارب',
        codeHave: 'وصلك رمز؟',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'عرض',
        kind: 'من هم؟',
        kinds: {
            grandparents: 'الجد والجدة',
            coparent: 'الوالد الآخر',
            family: 'الأقارب',
            friends: 'الأصدقاء',
        },
        label: 'ماذا تسمّونهم؟',
        labelPlaceholder: 'مثلًا: جدو وتيتا',
        via: 'كيف ندعوهم؟',
        viaEmail: 'بالبريد الإلكتروني',
        viaCode: 'برمز',
        email: 'البريد الإلكتروني',
        share: 'ماذا تشاركون؟',
        scopeAgenda: 'أجندة',
        scopeAgendaHint: 'مواعيد الأطفال الذين تختارهم فقط.',
        scopeBirthdays: 'أعياد الميلاد',
        scopeWishlists: 'قوائم الأمنيات',
        scopeContact: 'بيانات الاتصال',
        scopeMessages: 'الرسائل',
        scopeMessagesHint: 'يمكنهم المشاركة في المحادثات التي تضيفونهم إليها.',
        invite: 'دعوة',
        invited: 'أُرسلت الدعوة إلى {email}.',
        codeReady: 'أعطِ هذا الرمز إلى {label}',
        codeValid: 'صالح حتى {date}. يدخلونه في الأقارب ← وصلك رمز؟',
        weShare: 'نحن نشارك',
        theyShare: 'هم يشاركون',
        nothing: 'لا شيء بعد',
        statusPending: 'تمت الدعوة',
        statusActive: 'مربوط',
        statusRevoked: 'فُك الربط',
        statusEnded: 'فكّوا الربط من جهتهم',
        expires: 'ينتهي {date}',
        view: 'عرض',
        adjust: 'تعديل',
        revoke: 'فك الربط',
        revokeInvite: 'سحب الدعوة',
        remove: 'حذف',
        guestMoreDays: 'اعرض {count} أيام أخرى',
        endedHint: 'أوقفوا الربط من جهتهم. أزيلوه من هنا؛ يمكنكم الربط من جديد في أي وقت.',
        revokeConfirm: 'فك الربط مع {label}؟ بعدها لن يرى أحدكم شيئًا من الآخر.',
        revoked: 'تم فك الربط.',
        previewTitle: '{name} يريد الربط',
        previewShares: 'يشاركون معكم:',
        accept: 'ربط',
        accepted: 'تم الربط مع {name}. اختاروا أدناه ما تشاركونه بالمقابل.',
        acceptLabel: 'ماذا تسمّونهم؟',
        inviteGone: 'هذه الدعوة غير موجودة (بعد الآن) أو استُخدمت من قبل.',
        linkGoneTitle: 'هذا الرابط لم يعد يعمل',
        linkGoneBody: 'اطلب رمزًا جديدًا، أو أدخله أدناه.',
        toFamily: 'إلى الأقارب',
        emailMismatch: 'هذه الدعوة لبريد إلكتروني آخر.',
        alreadyLinked: 'أنتم مربوطون بالفعل.',
        contactTitle: 'بطاقة الاتصال الخاصة بنا',
        contactHint: 'تظهر فقط للعائلات التي تشارك معها بيانات الاتصال.',
        address: 'العنوان',
        phone: 'الهاتف',
        contactEmail: 'البريد الإلكتروني',
        note: 'ملاحظة',
        emptyTitle: 'لا أحد مربوط بعد',
        emptyBody: 'اربطوا الجد والجدة: يرون أعياد الميلاد والأمنيات، ويمكنهم إرسال رسائل.',
        guestTitle: '{name}',
        guestNothing: 'لا شيء مشترك بعد',
        guestNothingBody: 'هم يختارون ما يعرضونه.',
        guestAgenda: 'الأجندة (14 يومًا)',
        guestBirthdays: 'أعياد ميلاد قريبة',
        guestWishes: 'الأمنيات',
        guestContact: 'الاتصال',
        guestNoEvents: 'لا مواعيد في الأسبوعين القادمين.',
    },
    messages: {
        title: 'الرسائل',
        intro: 'آمنة: العائلة فقط والعائلات التي تربطونها. بلا إعلانات وبلا خوارزميات.',
        parentsReadAll: 'يقرأ الوالدان كل المحادثات، ومنها محادثات الأطفال.',
        family: 'العائلة',
        add: 'محادثة',
        addTitle: 'محادثة جديدة',
        fieldTitle: 'اسم المحادثة',
        fieldTitlePlaceholder: 'مثلًا: جدو وتيتا',
        fieldWho: 'من يشارك؟',
        fieldLinks: 'العائلات المربوطة',
        fieldLinksHint: 'فقط العائلات التي تشاركون معها الرسائل.',
        create: 'إنشاء المحادثة',
        placeholder: 'اكتب رسالة…',
        send: 'إرسال',
        stickers: 'الملصقات',
        record: 'تسجيل صوتي',
        recording: 'جارٍ التسجيل… اضغط للإيقاف',
        voice: 'رسالة صوتية',
        play: 'تشغيل',
        hidden: 'أخفى أحد الوالدين هذه الرسالة',
        hide: 'إخفاء',
        fromLinked: 'من العائلات المربوطة',
        pickConversation: 'اختر محادثة',
        emptyTitle: 'لا رسائل بعد',
        emptyBody: 'ابدأ في محادثة العائلة.',
        kidEmptyBody: 'أرسل ملصقًا!',
        newMessages: 'رسائل جديدة',
        noMember: 'اربط حسابك أولًا بأحد أفراد العائلة لإرسال الرسائل.',
        sticker: 'ملصق',
    },
    phrase: {
        love: 'أحبك',
        comeHome: 'هل ستأتي إلى البيت؟',
        hungry: 'أنا جائع',
        done: 'انتهيت!',
        miss: 'اشتقت إليك',
        play: 'هل تأتي لتلعب؟',
    },
    wishPicto: {
        gift: 'هدية',
        play: 'دمية',
        puzzle: 'أحجية',
        drawing: 'أدوات رسم',
        crafts: 'أدوات أشغال يدوية',
        reading: 'كتاب',
        gaming: 'جهاز ألعاب',
        cycling: 'دراجة',
        soccer: 'كرة قدم',
        skating: 'زلاجات',
        swimming: 'أدوات سباحة',
        dance: 'درس رقص',
        'music-lesson': 'درس موسيقى',
        guitar: 'غيتار',
        piano: 'بيانو',
        drums: 'طبول',
        unicorn: 'حصان وحيد القرن',
        dino: 'ديناصور',
        rocket: 'صاروخ',
        bear: 'دب',
        rabbit: 'أرنب',
        cat: 'قطة',
        dolphin: 'دلفين',
        butterfly: 'فراشة',
        rainbow: 'قوس قزح',
        sunflower: 'زهور',
        'ice-cream': 'مثلجات',
        pizza: 'بيتزا',
        popcorn: 'فشار',
        cinema: 'إلى السينما',
        zoo: 'إلى حديقة الحيوان',
        museum: 'إلى المتحف',
        camping: 'التخييم',
        sleepover: 'مبيت عند الأصدقاء',
        party: 'حفلة',
        trophy: 'كأس',
    },
    kiosk: {
        wishesEntry: 'الأمنيات',
        messagesEntry: 'الرسائل',
        myWishes: 'أمنياتي',
        newWish: 'أمنية جديدة',
        pickPicture: 'اختر صورة',
        howMuch: 'كم تريدها؟',
        addToList: 'إلى قائمتي',
        removeAsk: 'إزالة؟',
        wishAdded: 'في قائمتك الآن!',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'في قائمتك الآن',
        noWishes: 'لا أمنيات بعد',
        noWishesBody: 'اضغط على علامة + واختر صورة.',
        conversations: 'المحادثات',
        unread: {
            zero: 'لا جديد',
            one: '{count} جديدة',
            two: '{count} جديدة',
            few: '{count} جديدة',
            many: '{count} جديدة',
            other: '{count} جديدة',
        },
        wishRemoved: 'أُزيلت {title}',
        messageSent: 'أُرسلت',
        oops: 'تراجع',
        typeOwn: 'اكتب بنفسك',
        typeLabel: 'رسالتك',
        typePlaceholder: 'ماذا تريد أن تقول؟',
        send: 'إرسال',
        closeTyping: 'انتهيت من الكتابة',
        notYou: 'لست أنت؟',
        newMessages: 'رسائل جديدة',
        alreadyOnList: 'موجودة في قائمتك!',
        alreadyOnListCalm: 'موجودة في قائمتك',
        morePictures: 'صور أخرى',
        morePhrases: 'جمل أخرى',
    },
};
//# sourceMappingURL=family.ar.js.map